import { AutogenModelVitalSignsProfile, AutogenRowVitalSignsProfile } from "./autogen/AutogenModelVitalSignsProfile";

export class ModelVitalSignsProfile extends AutogenModelVitalSignsProfile<RowVitalSignsProfile> {
	constructor() {
		super(RowVitalSignsProfile);
	}
}

export class RowVitalSignsProfile extends AutogenRowVitalSignsProfile {
}
